import { Amplify } from 'aws-amplify';
import APP_CONFIG from './app-config.json';
import AMPLIFY_OUTPUTS from './amplify_outputs.json';
import { Utils } from '../utils/amplify-utils';

export class JourneyClientBootstrap {


    async bootstrapApp(): Promise<boolean>{
        
        // Find the course config
        const courseConfig = APP_CONFIG;

        console.log('+++++++++++++++++ +++++++++++++++++ +++++++++++++++++ ');
        console.log(`course [${courseConfig.name}] branch [${courseConfig.branch}]`);
        console.log('+++++++++++++++++ +++++++++++++++++ +++++++++++++++++ ');
  
        // const config = await this.loadJson(`/assets/config/amplify_outputs-${courseConfig.branch}.json`);
        Amplify.configure(AMPLIFY_OUTPUTS);

        //cover image
        Utils.appConfig = courseConfig;
        return true;
    }

    private async loadJson(filePath: string): Promise<any> {
        try {
          const response = await fetch(filePath);
          if (!response.ok) {
            throw new Error(`Failed to fetch ${filePath}: ${response.statusText}`);
          }
          const data = await response.json(); // Parse JSON
          console.log('JSON Data:', data);
          return data;
        } catch (error) {
          console.error('Error loading JSON file:', error);
          throw error;
        }
      }
}